import * as trace from 'owa-trace';
import { hasQueryStringParameter } from 'owa-querystring';

const startTime = 'startTime';
const name = 'name';

/**
 * Copy perf entry to the global _pageTimings object so that PAS tool can read and report in results
 */
export default function copyCustomMetricsToPageTimings(): void {
    if (hasQueryStringParameter('cpm')) {
        try {
            const perfEntries = window?.performance?.getEntriesByType('mark');
            if (perfEntries.length > 0) {
                window._pageTimings = window._pageTimings || {};
                for (let i = 0; i < perfEntries.length; i++) {
                    const perfEntry = perfEntries[i];
                    if (startTime in perfEntry && name in perfEntry) {
                        window._pageTimings[perfEntry[name]] = perfEntry[startTime];
                    }
                }
            }
        } catch (e) {
            trace.errorThatWillCauseAlert('copyCustomMetricsToPageTimings failed:' + e);
        }
    }
}
